import { HasKind, KindOf, TypeForKind } from '@/utilities/HasKind';

import { Crumbs as Crumbs } from './Crumbs';

export type Crumble<T> = (slice: T) => Crumbs;

export type Bakery<T extends HasKind<string>> = {
  [K in KindOf<T>]: Crumble<TypeForKind<T, K>>;
};

export const noCrumbs: Crumble<unknown> = () => {
  return {};
};
